import React from 'react';
import cx from 'classnames';

import './index.scss';

const userMessages = ['Hi there! Can you help me book an appointment?'];
const getFirstCharecter=(business_name)=>{
    if(business_name && business_name.length>0){
        return business_name.charAt(0)
    }
    return 'T'
}
const Otherbody = ({message,logo,business_name,actioncolor,brandcolor,usermessage,emailInit, email_capture_message}) => {
  return (
                 <div className="preview-body">
                            <div className="bot-message">
                            {logo? (<img className="business-logo" src={logo} />):(<div className="business-char">{getFirstCharecter(business_name)}</div>)}
                                <div className="message">{(message)?message:'Hi there! Can you help me book an appointment?'}</div>
                            </div>
                            { usermessage && userMessages.map(message=>{
                                return <div className="user-message">
                                            <div className="message" style={{backgroundColor:brandcolor}}>{message}</div>
                                        </div>
                                })
                            }
                            {usermessage &&
                            <div className="bot-message">
                               {logo? (<img className="business-logo" src={logo} />):(<div className="business-char">{getFirstCharecter(business_name)}</div>)}
                                <div className="message">Happy to! What service are you looking for?</div>
                            </div>
                            }
                            {!emailInit && !usermessage &&
                            <>
                            <div className="user-message">
                                <div className="message" style={{backgroundColor:brandcolor}}>Hi Sasha, do you have a free slot tomorrow ?</div>
                            </div>
                            <div className="bot-message">
                            {logo && <img className="business-logo" src={logo} />}
                             <div className="message">Which service are you looking to book?</div>
                            </div>
                            </>
                            }
                            {emailInit && !usermessage &&
                            <>
                            <div className="user-message">
                                <div className="message" style={{backgroundColor:brandcolor}}>Hi Sasha I left my spctables behind yesterday . Let me know if you find it</div>
                            </div>
                            <div className="bot-message">
                            {logo && <img className="business-logo" src={logo} />}
                            <div className="message">{email_capture_message}</div>
                            </div>
                            </>
                            }
                        </div>
  );
};

export default Otherbody;
